import React, {useState, useContext, useEffect} from "react";
import PropType from "prop-types";
import PlayerTableRow from "./PlayerTableRow";
import "./PlayerTable.css";
import { GreenMachineContext } from "../GreenMachineContext";
import PositionFilter from "./PositionFilter";
import PlayerExposureRow from "./PlayerExposureRow";

export default function PlayerTable(props) {
  const { greenMachineSessionID, gameTypeLineupSet, selectedSportName, isCptMode } = useContext(
    GreenMachineContext
  );

  const [searchText, setSearchText] = useState(undefined);
  const [positionFilter, setPositionFilter] = useState(
    gameTypeLineupSet
      .filter((lineupPos) => lineupPos.node.selectable)
      .map((lineupPos) => lineupPos.node.rosterSlot.name)
  );

  useEffect(() => {
    if (selectedSportName === "NFL" && !isCptMode) {
      setPositionFilter(
          ["QB"]
      )
    }
  }, []);

  function updateSearchText(e) {
    e.preventDefault();

    setSearchText(e.target.value.toLowerCase());
  }

  function updatePositionFilter(position) {
    const index = positionFilter.indexOf(position);

    if (index > -1) {
      positionFilter.splice(index, 1);
      setPositionFilter([...positionFilter]);
    } else {
      setPositionFilter([...positionFilter, position]);
    }
  }

  return (
    <>
      <div className="gm-player-table-filters">
        {gameTypeLineupSet.map((lineupPos) => {
          if (!lineupPos.node.selectable) {
            return null;
          }

          return (
            <PositionFilter
              key={lineupPos.node.id}
              rosterSlot={lineupPos.node.rosterSlot.name}
              updatePositionFilter={updatePositionFilter}
              selected={positionFilter.includes(lineupPos.node.rosterSlot.name)}
            />
          );
        })}
      </div>

      <input
        type="text"
        placeholder="Search Players"
        onChange={updateSearchText}
      />

      <table className="gm-player-table">
        <tr>
          <th>Player</th>
        </tr>
        {props.players.map((player) => {
          let searchPlayer = player;

          if (props.selectedPlayers === undefined) {
            searchPlayer = player.slatePlayer;
          }

          if (
            (searchText &&
              !searchPlayer.player.name.toLowerCase().includes(searchText)) ||
            !searchPlayer.rosterSlots.edges
              .map((edge) => edge.node.name)
              .some((item) => positionFilter.includes(item))
          ) {
            return null;
          }

          if (!props.exposure) {
            return (
              <PlayerTableRow
                key={player.id}
                player={player}
                updateUnsavedSelections={props.updateChanges}
                selectedPlayers={props.selectedPlayers}
                sessionSelected={props.sessionSelected}
              />
            );
          } else {
            return (
              <PlayerExposureRow
                key={player.id}
                player={player}
                updateUnsavedSelections={props.updateChanges}
                sessionChanges={props.sessionExposureChanges}
              />
            );
          }
        })}
      </table>
    </>
  );
}

PlayerTable.propTypes = {
  players: PropType.arrayOf(PropType.object).isRequired,
};
